/**
 * The additive node material every placeholder effect shares (TSL only, per CLAUDE.md). Its
 * extra render targets are left as the scene wrote them (see mrt.ts), so ambient occlusion, TAAU
 * and SSGI never see the effects.
 */
import { AdditiveBlending, DoubleSide, MeshBasicNodeMaterial } from 'three/webgpu';
import { color, uniform } from 'three/tsl';

import { effectMrt } from './mrt.js';

export interface VfxMaterial {
  material: MeshBasicNodeMaterial;
  /** Overall brightness uniform. */
  intensity: { value: number };
}

export function createVfxMaterial(hex: number, intensity = 1): VfxMaterial {
  const material = new MeshBasicNodeMaterial();
  const strength = uniform(intensity);
  material.colorNode = color(hex).mul(strength);
  material.transparent = true;
  material.blending = AdditiveBlending;
  material.depthWrite = false;
  material.side = DoubleSide;
  material.mrtNode = effectMrt();
  return { material, intensity: strength };
}
